export function cleaningData(data) {
    return data.toString().replace(/[\u2000-\u206F\u2E00-\u2E7F]/g, '').trim()
}